(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gt-brand-faith"] && !Shopify.designMode) return;
  try {
    
(() => {
  const preserveView = () => {
    if (!document.querySelector('.gt-faith')) return;
    document.querySelectorAll('facet-filters-form form, menu-drawer form').forEach(form => {
      if (!form.querySelector('input[name="view"]')) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'view'; input.value = 'brand-faith';
        form.appendChild(input);
      }
    });
  };
  preserveView();
  new MutationObserver(preserveView).observe(document.getElementById('MainContent'), {childList:true,subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-brand-seymour-duncan"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('.gt-sd');
  if (!root) return;
  root.querySelectorAll('.gt-sd-tag-group').forEach(group => {
    group.addEventListener('toggle', () => {
      if (group.open) root.querySelectorAll('.gt-sd-tag-group').forEach(other => { if (other !== group) other.open = false; });
    });
  });
  const activeConstraint = new URL(location.href).searchParams.get('constraint');
  if (activeConstraint && location.pathname.includes('/collections/vendors')) {
    const form = root.querySelector('.gt-sd-filters');
    let input = form.querySelector('input[name=constraint]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'constraint'; form.appendChild(input); }
    input.value = activeConstraint;
    root.querySelectorAll('.gt-sd-tags a').forEach(link => {
      if (new URL(link.href, location.origin).searchParams.get('constraint') === activeConstraint) link.parentElement.classList.add('is-active');
    });
    const selected = document.createElement('p');
    selected.append(document.createTextNode('Selected: ' + activeConstraint.replace(/^(family|series|type)-/, '').replaceAll('-', ' ') + ' · '));
    const clear = document.createElement('a');
    clear.textContent = 'Clear selection';
    clear.href = root.dataset.collectionResetUrl;
    selected.appendChild(clear);
    if (!root.querySelector('.gt-sd-selection')) root.querySelector('.gt-sd-tags').appendChild(selected);
  }
  root.querySelectorAll('a[href]').forEach(link => {
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/collections/')) return;
    url.searchParams.set('view', 'brand-seymour-duncan');
    if (url.pathname.startsWith('/collections/vendors')) url.searchParams.set('q', 'Seymour Duncan');
    if (new URL(location.href).searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', new URL(location.href).searchParams.get('preview_theme_id'));
    link.href = url.toString();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-brand-tokai"] && !Shopify.designMode) return;
  try {
    
function initTokaiNavigation(){document.querySelectorAll('.gt-tokai').forEach(root=>{const current=new URL(location.href);root.querySelectorAll('[data-tokai-nav], .gt-tokai__pagination a[href]').forEach(a=>{const u=new URL(a.href,location.origin);u.searchParams.set('view','brand-tokai');if(current.searchParams.has('preview_theme_id'))u.searchParams.set('preview_theme_id',current.searchParams.get('preview_theme_id'));a.href=u.toString()});root.querySelectorAll('form').forEach(f=>{if(current.searchParams.has('preview_theme_id')&&!f.querySelector('[name="preview_theme_id"]')){const i=document.createElement('input');i.type='hidden';i.name='preview_theme_id';i.value=current.searchParams.get('preview_theme_id');f.appendChild(i)}})})}initTokaiNavigation();document.addEventListener('shopify:section:load',initTokaiNavigation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-brand-yamaha"] && !Shopify.designMode) return;
  try {
    
(() => {
  function prepare() {
    if (!document.querySelector('[data-yamaha-page]')) return;
    const current = new URL(window.location.href);
    document.querySelectorAll('#MainContent a[href]').forEach(a => {
      const url = new URL(a.getAttribute('href'), current.origin);
      if (url.origin !== current.origin || !url.pathname.startsWith('/collections/')) return;
      url.searchParams.set('view', 'brand-yamaha');
      if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
      if (a.closest('.gt-yamaha') && !url.searchParams.has('filter.v.availability')) {
        current.searchParams.getAll('filter.v.availability').forEach(value => url.searchParams.append('filter.v.availability', value));
      }
      if (a.closest('.pagination-wrapper') && !url.searchParams.has('filter.v.availability')) {
        url.searchParams.append('filter.v.availability', '1');
        url.searchParams.append('filter.v.availability', '0');
      }
      const next = url.pathname + url.search + url.hash;
      if (a.getAttribute('href') !== next) a.setAttribute('href', next);
    });
    document.querySelectorAll('#MainContent facet-filters-form form').forEach(form => {
      if (!form.querySelector('input[name="view"]')) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'view'; input.value = 'brand-yamaha'; form.append(input);
      }
    });
  }
  document.addEventListener('DOMContentLoaded', prepare);
  document.addEventListener('shopify:section:load', prepare);
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(prepare).observe(main, {childList:true,subtree:true});
  prepare();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgt-cort-collection"] && !Shopify.designMode) return;
  try {
    
function initCortFilters(root) {
  root.querySelectorAll('.tgt-cort-filter-form').forEach(form => {
    if(form.dataset.ready)return;
    form.dataset.ready='true';
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const data=new FormData(form);
      const tags=['cort_type','cort_series','cort_family','cort_left'].map(k=>data.get(k)).filter(Boolean);
      const url=new URL(form.dataset.collectionUrl+(tags.length?'/'+tags.join('+'):''),window.location.origin);
      url.searchParams.set('sort_by',data.get('sort_by'));
      const preview=new URL(window.location.href).searchParams.get('preview_theme_id');
      if(preview)url.searchParams.set('preview_theme_id',preview);
      url.hash=form.dataset.anchor;
      window.location.assign(url.href);
    });
  });
}
initCortFilters(document);
document.addEventListener('shopify:section:load',event=>initCortFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgt-emg-collection"] && !Shopify.designMode) return;
  try {
    
function prepareEMGFilters() {
  document.querySelectorAll('.emg-page').forEach((page) => {
    const drawer = page.querySelector('.emg-filter-drawer');
    if (drawer && !drawer.dataset.prepared) {
      drawer.open = !window.matchMedia('(max-width: 749px)').matches;
      drawer.dataset.prepared = 'true';
    }
    page.querySelectorAll('.emg-filters a[href]').forEach((link) => {
      const url = new URL(link.href);
      const sorting = new URL(window.location.href).searchParams.get('sort_by');
      if (sorting) url.searchParams.set('sort_by', sorting);
      url.hash = page.querySelector('.emg-catalogue').id;
      link.href = url.toString();
    });
  });
}
prepareEMGFilters();
document.addEventListener('shopify:section:load', prepareEMGFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgt-ibanez-collection"] && !Shopify.designMode) return;
  try {
    
function initIbanezFilters(root) {
  root.querySelectorAll('.tgt-ibanez-filter-form').forEach(form => {
    if(form.dataset.ready)return;
    form.dataset.ready='true';
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const data=new FormData(form);
      const tags=[...form.querySelectorAll('[data-preserved-tag]')].map(input=>input.value).concat(['ibanez_type','ibanez_series','ibanez_family','ibanez_left'].map(k=>data.get(k)).filter(Boolean));
      const url=new URL(form.dataset.collectionUrl+(tags.length?'/'+tags.join('+'):''),window.location.origin);
      url.searchParams.set('sort_by',data.get('sort_by'));
      url.searchParams.set('view','ibanez');
      const preview=new URL(window.location.href).searchParams.get('preview_theme_id');
      if(preview)url.searchParams.set('preview_theme_id',preview);
      url.hash=form.dataset.anchor;
      window.location.assign(url.href);
    });
  });
}
document.addEventListener('click',event=>{const link=event.target.closest('.tgt-ibanez a');if(!link)return;const url=new URL(link.href,location.origin);if(url.origin===location.origin && url.pathname.includes('/collections/')){url.searchParams.set('view','ibanez');const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);link.href=url.href;}});
initIbanezFilters(document);
document.addEventListener('shopify:section:load',event=>initIbanezFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgt-prs-collection"] && !Shopify.designMode) return;
  try {
    
function initPRSFilters(root) {
  root.querySelectorAll('.tgt-prs-filter-form').forEach(form => {
    if(form.dataset.ready)return;
    form.dataset.ready='true';
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const data=new FormData(form);
      const tags=['prs_type','prs_series','prs_family','prs_left'].map(k=>data.get(k)).filter(Boolean);
      const url=new URL(form.dataset.collectionUrl+(tags.length?'/'+tags.join('+'):''),window.location.origin);
      url.searchParams.set('sort_by',data.get('sort_by'));
      url.hash=form.dataset.anchor;
      window.location.assign(url.href);
    });
  });
}
initPRSFilters(document);
document.addEventListener('shopify:section:load',event=>initPRSFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgt-washburn-collection"] && !Shopify.designMode) return;
  try {
    
function initWashburnFilters(root) {
  root.querySelectorAll('.tgt-washburn-filter-form').forEach(form => {
    if(form.dataset.ready)return;
    form.dataset.ready='true';
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const data=new FormData(form);
      const tags=['washburn_type','washburn_series','washburn_family','washburn_left'].map(k=>data.get(k)).filter(Boolean);
      const url=new URL(form.dataset.collectionUrl+(tags.length?'/'+tags.join('+'):''),window.location.origin);
      url.searchParams.set('sort_by',data.get('sort_by'));
      url.searchParams.set('view','washburn');
      const preview=new URL(window.location.href).searchParams.get('preview_theme_id');
      if(preview)url.searchParams.set('preview_theme_id',preview);
      url.hash=form.dataset.anchor;
      window.location.assign(url.href);
    });
  });
}
initWashburnFilters(document);
document.addEventListener('shopify:section:load',event=>initWashburnFilters(event.target));

  } catch(e) { console.error(e); }
})();
})();
